import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactCTA = () => {
  return (
    <section className="py-16 bg-gradient-heritage text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 heritage-pattern opacity-10"></div>
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-64 h-64 opacity-10">
        <svg viewBox="0 0 200 200" className="w-full h-full">
          <defs>
            <pattern id="textile-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle cx="10" cy="10" r="2" fill="currentColor" opacity="0.3" />
            </pattern>
          </defs>
          <rect width="200" height="200" fill="url(#textile-pattern)" />
        </svg>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-poppins font-bold mb-4">
            Ready to Start Your Fabric Journey?
          </h2>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            Join hundreds of satisfied clients who trust Kunjvihari Impex for their fabric requirements and wholesale needs.
          </p>
        </div>

        {/* Trust Indicators */}
        <div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-golden mb-2">1500+</div>
              <div className="text-white/80">Happy Clients</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-golden mb-2">10+</div>
              <div className="text-white/80">Years Experience</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-golden mb-2">24/7</div>
              <div className="text-white/80">Support Available</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-golden mb-2">100%</div>
              <div className="text-white/80">Quality Guarantee</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;